import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { FlexBox } from '../box';
import { IconButton } from '../button';
import { Tabs } from '../tabs';
import { Tooltip } from '../tooltip';
import { Typography } from '../typography';
import { ActionButtons, sortPageHeaderActions } from './header';
export const TabHeader = React.forwardRef((props, ref) => {
    const { title, info, actions: _actions, items: _items, selectedTabIndex, onTabChange, className, 'data-role': dataRole = 'page-tab-header', 'data-role-value': dataRoleValue } = props;
    const actions = _actions && sortPageHeaderActions(_actions);
    const HeaderRow = (_jsxs(FlexBox, { hAlign: "space-between", vAlign: "center", children: [_jsxs(FlexBox, { gap: 0.75, vAlign: "center", children: [title && (_jsx(Typography, { variant: "h6", color: "text.primary", children: title })), info && (_jsx(Tooltip, { title: info, children: _jsx(IconButton, { icon: "IconInfo", size: "small" }) }))] }), actions?.length && _jsx(ActionButtons, { actions: actions })] }));
    const items = HeaderRow
        ? _items.map((item) => {
            const Original = item.content;
            const Wrapped = () => (_jsxs(FlexBox, { stack: true, gap: 2, height: "100%", minHeight: 0, stretch: true, autoShrink: true, children: [HeaderRow, _jsx(FlexBox, { minHeight: 0, stretch: true, autoShrink: true, children: _jsx(Original, {}) })] }));
            return { ...item, content: Wrapped };
        })
        : _items;
    return (_jsx(FlexBox, { ref: ref, className: className, "data-role": dataRole, "data-role-value": dataRoleValue, stretch: true, minHeight: 0, bgcolor: "background.paper", sx: {
            '& [data-role="tabs"]': {
                overflow: 'visible'
            },
            '& [data-role="tab-content"]': ({ spacing }) => ({
                overflow: 'auto',
                flex: '1 1 0',
                height: '100%',
                width: `calc(100% + ${spacing(7)})`,
                marginLeft: spacing(-4),
                paddingLeft: spacing(4),
                marginRight: spacing(-4),
                paddingRight: spacing(2)
            })
        }, children: _jsx(Tabs, { items: items, selectedTabIndex: selectedTabIndex, onTabChange: onTabChange }) }));
});
TabHeader.displayName = 'TabHeader';
